import './lightzoom';

export function initializeLightzoom () {
  $( '.lightzoom' ).lightzoom({
    speed:                 100,   // скорость появления
    imgPadding:            1,    // значение отступа у изображения
    overlayOpacity:        '0.5', // прозрачность фона (от 0 до 1)
    viewTitle:             false, // true, если надо показывать подпись к изобажению
    isOverlayClickClosing: true, // true, если надо закрывать окно при клике по затемненной области
    isWindowClickClosing:  true, // true, если надо закрывать окно при клике по любой области
    isEscClosing:          true, // true, если надо закрывать окно при нажатии на кнопку Esc
    boxClass:              '',    // позволяет задавать класс окну обертке (с версии 1.1.0)
    overlayColor:          '',    // позволяет задавать цвет фону (с версии 1.1.0)
    titleColor:            '',    // позволяет задавать цвет подписи (с версии 1.1.0)
  });
}